import React, { useState, useRef, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  DialogActions,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "./SessionManager";
// import constants from "../common/constants";
import { useDispatch } from "react-redux";
import { handleLogOut } from "./Methods";

export const SessionTimeoutModal = () => {
  const [open, setOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const timeoutRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = getAccessToken(window); // Hook to get the current auth token
  const LogOut = () => {
    clearInterval(timeoutRef.current);
    timeoutRef.current = null; // Reset the reference
    setOpen(false);
    handleLogOut(dispatch, navigate);
  };

  const handleOnIdle = () => {
    if (!authToken) return; // Do nothing if there's no auth token
    clearInterval(timeoutRef.current);
    setOpen(true);
    timeoutRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          return LogOut();
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  const resetTimer = () => {
    setOpen(false);
    clearInterval(timeoutRef.current);
    timeoutRef.current = null; // Reset the reference
    setTimeLeft(60); // Reset the timer
  };

  useIdleTimer({
    timeout: 1000 * 60 * 15, // 15 minutes
    onIdle: handleOnIdle,
    debounce: 500,
    events: authToken ? undefined : [], // Disable idle timer events if no auth token
  });
  const handleUserActivity = () => {
    resetTimer();
  };
  // Clear the interval when the component unmounts
  useEffect(() => {
    return () => {
      clearInterval(timeoutRef.current);
    };
  }, []);

  // Stop the timer if the auth token becomes invalid
  useEffect(() => {
    if (!authToken) {
      resetTimer();
    }
  }, [authToken]);
  return (
    <>
      {getAccessToken(window) && (
        <Dialog
          open={open}
          onClose={resetTimer}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            color="error"
            sx={{ fontWeight: "bold" }}
          >
            {"Session Expiry Warning"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Your session will be expired in{" "}
              <Typography component="span" variant="h6" color={"error"}>
                {timeLeft}
              </Typography>{" "}
              seconds. Click on any one of the option below to proceed further.
            </DialogContentText>
            <DialogActions>
              <Button onClick={handleUserActivity} color="primary" autoFocus>
                Continue your Session
              </Button>
              <Button onClick={() => LogOut()} color="primary">
                Logout
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
